module.exports = __webpack_public_path__ + "img/subBan01.ba16aeb3.jpg";